const mobileURLProduction = "bit.ly/app-photonow"; // https://mobile.photonow.com.br/code
const mobileURLDefault = "https://mobile-teste-cabine.web.app"; // https://mobile.release.photonow.com.br/code
const baseURL =
  document.location.hostname == "cabine-teste.web.app" ||
    document.location.hostname == "localhost"
    ? "https://mobile-teste-cabine.web.app/"
    : "https://mobile.photonow.com.br/";

function GetSiteUrl() {
  return document.location.hostname == "cabine-teste.web.app" ?
    "https://cabine-teste.web.app/" :
    document.location.hostname == "localhost"
      ? "http://localhost:8080/"
      : "https://app.photonow.com.br/";
}

export const siteURL = GetSiteUrl();

export { baseURL, mobileURLDefault, mobileURLProduction };